import { useAlert } from '@btime/react-messager'
import React from 'react'

import { PermissionChecker } from '../../session'
import { getQueryParam } from '../../../utils/helpers/url'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import EditChecklistFormWrapper from './EditChecklistFormWrapper'
import PageHeader from './PageHeader'

const EditChecklistPage = ({ id }) => {
  const navigate = useNavigation()
  const redirectToSwordFish = getQueryParam('swordfish')
  const modal = useAlert()

  if (redirectToSwordFish === 'true') {
    modal.confirm({ title: 'Viva o peixe-espada?' })
    navigate('http://justfunfacts.com/wp-content/uploads/2018/04/swordfish.jpg')
  }

  return (
    <AbsolutePageTemplate>
      <PageHeader id={id} />
      <PermissionChecker permission={!id ? 'createChecklist' : 'editChecklist'}>
        <EditChecklistFormWrapper id={id} />
      </PermissionChecker>
    </AbsolutePageTemplate>
  )
}

export default EditChecklistPage
